export default "__VITE_ASSET__BSXrcF_5__"